import React from "react";
import { Card, Button, Tooltip } from "@blueprintjs/core";
import CountUp from "react-countup";
import { Trans } from "react-i18next";
import i18n from "../../i18n";

import { getCurrencySymbol } from "../../utils/mef";

export default function KeyData(props) {
  var float = props.float !== undefined ? props.float : 0;

  let unit = "";
  if (props.unit !== undefined) {
    if (props.unit === "€") {
      unit = getCurrencySymbol();
    } else unit = props.unit;
  }

  const details = [];
  const detailslist = [];
  let i = 0;
  if (props.details !== undefined) {
    if (typeof props.details === "string" || props.details instanceof String)
      details.push(<div key={"det" + i++}>{props.details}</div>);
    else
      for (const lbl in props.details) {
        if (props.details[lbl] !== 0)
          detailslist.push(
            <div key={"det" + i++}>
              <Trans>{lbl}</Trans>: {props.details[lbl]}
            </div>
          );
      }
  }

  return (
    <Card className={props.className !== undefined ? props.className : ""}>
      {props.onCogClick !== undefined ? (
        <Tooltip content={i18n.t("edit key value")}>
          <Button
            icon="cog"
            minimal={true}
            onClick={() => props.onCogClick()}
          />
        </Tooltip>
      ) : null}

      {props.onChartClick !== undefined ? (
        <Tooltip content={i18n.t("evolution of the key value")}>
          <Button
            icon="timeline-line-chart"
            minimal={true}
            onClick={() => props.onChartClick()}
          />
        </Tooltip>
      ) : null}

      <div className="noselect">
        <Trans>{props.label}</Trans>
      </div>

      <div className="flexbox-center noselect">
        <b>
          <CountUp
            end={props.data}
            decimals={float}
            separator=" "
            decimal=","
            suffix={unit}
          />
        </b>
        {details.length > 0 ? details : null}
      </div>
      {detailslist.length > 0 ? detailslist : null}
    </Card>
  );
}
